import React from "react";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";
import { Text } from "@components/formx";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { Body, RegularButton, SecondaryButton } from "@components";
import locale from "@bonliva-crm/locale";
import { Grid, Divider } from "@material-ui/core";
import FormControls from "@components/forms/common/FormControls";
import { FormError } from "@components/forms/common/FormError";
import { ConsultantForm_EmergencyContactsFragment } from "@graphql";

type Contact = ConsultantForm_EmergencyContactsFragment["items"][0];
export const initialContact: Contact = {
  name: "",
  phone: "",
  relation: ""
};

export function EmergencyContactInfo() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();
  const classes = useStyles({});

  return (
    <>
      {editorStore.emergencyContactsItems.length === 0 && (
        <Grid item>
          <Body color="textSecondary" style={{ textAlign: "center" }}>
            ({locale.EmptyHere.toLocaleLowerCase()})
          </Body>
        </Grid>
      )}

      {editorStore.emergencyContactsItems.map((item, i) => {
        const fieldName = `emergencyContacts.items.${i}`;

        return (
          <Grid
            key={i}
            container
            spacing={1}
            className={classes.item}
            data-test="EmergencyContact"
          >
            <Grid item xs={12}>
              <Text label={locale.Name} name={`${fieldName}.name`} />
            </Grid>

            <Grid item xs={12} md={6}>
              <Text label={locale["Phone number"]} name={`${fieldName}.phone`} />
            </Grid>

            <Grid item xs={12} md={6}>
              <Text label={locale.Relationship} name={`${fieldName}.relation`} />
            </Grid>

            <FormControls
              fitted
              right={
                <RegularButton
                  onClick={() => editorStore.removeEmergencyContacts(i)}
                  data-test={`DeleteButton[${i}]`}
                >
                  {locale.Delete}
                </RegularButton>
              }
            />

            <Grid item xs={12}>
              <Divider style={{ flex: 1 }} />
            </Grid>
          </Grid>
        );
      })}

      {typeof editorStore.emergencyContactErrors === "string" && (
        <FormError message={editorStore.emergencyContactErrors} />
      )}

      <FormControls
        fitted
        right={
          <SecondaryButton
            onClick={() => editorStore.addEmergencyContact({ ...initialContact })}
            variant="text"
            data-test="AddButton"
          >
            {locale["Add contact"]}
          </SecondaryButton>
        }
      />
    </>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  item: {
    "&:not(:last-child)": {
      marginBottom: theme.spacing()
    }
  }
}));
